import { createSlice } from "@reduxjs/toolkit";
// utils
import axios from "../../utils/axios";
//
import { dispatch } from "../store";

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: null,
  wallet: {},
};

const slice = createSlice({
  name: "wallet",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // STOP LOADING
    stopLoading(state) {
      state.isLoading = false;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET WALLET
    getWalletSuccess(state, action) {
      state.isLoading = false;
      state.wallet = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const {
  startLoading,
  stopLoading,
} = slice.actions;

// ----------------------------------------------------------------------

export function getWallet() {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get("/api/v1/wallet/ballance");
      dispatch(slice.actions.getWalletSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export async function postRecharge(data) {
  const response = await axios.post(`/api/v1/dashboard-supervisor/deposit-getnet`, data);
  return response.data;
}

export async function postRetrait(data) {
  const response = await axios.post(`/api/v1/wallet/retrait`, data);
  return response.data;
}
